<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Ürün Grubu Ekle/Güncelle</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">

      <div class="form-group">
        <label>Adı</label>
        <input type="text" formControlName="name" class="form-control">
      </div>
      
        <div class="form-group">
        <label>İngilizce Adı</label>
        <input type="text" formControlName="nameEnglish" class="form-control">
      </div>
<div class="form-group">
        <label>Ürün Tipi (ProductType)</label>
        <input type="text" formControlName="productType" class="form-control">
      </div>
      <div class="form-group">
        <label>Ürün Tipi İngilizce</label>
        <input type="text" formControlName="productTypeEnglish" class="form-control">
      </div>



      <div class="form-group">
        <label>A Değeri</label>
        <input type="text" formControlName="a" class="form-control">
      </div>
      
      <div class="form-group">
        <label>A Birimi</label>
        <input type="text" formControlName="aunit" class="form-control">
      </div>
        <div class="form-group">
        <label>A Birimi İngilizce</label>
        <input type="text" formControlName="aunitEnglish" class="form-control">
      </div>



      <div class="form-group">
        <label>Uygulama bölgesi</label>
        <input type="text" formControlName="applicationRegion" class="form-control">
      </div>

      
      <div class="form-group">
        <label>Uygulama bölgesi İngilizce</label>
        <input type="text" formControlName="applicationRegionEnglish" class="form-control">
      </div>


   <div class="form-group">
        <label>Uygulanan ürünün deriye temas ettiği alan (cm2): </label>
        <input type="text" formControlName="contactAreaCm2" class="form-control">
      </div>

   <div class="form-group">
        <label>Normal ve makul olarak öngörülebilir kullanım koşullarında, uygulama başına miktar (g): </label>
        <input type="text" formControlName="amountPerApplicationGrams" class="form-control">
      </div>
    
      
      <div class="form-group">
        <label>Uygulanan ürünün temas süresi ve uygulama sıklığı: </label>
        <input type="text" formControlName="durationFrequency" class="form-control">
      </div>

        
      <div class="form-group">
        <label>Uygulanan ürünün temas süresi ve uygulama sıklığı İngilizce: </label>
        <input type="text" formControlName="durationFrequencyEnglish" class="form-control">
      </div>


      
      <div class="form-group">
        <label>Muhtemel (öngörülebilir) maruziyet yolları</label>
        <input type="text" formControlName="foreseeable" class="form-control">
      </div>
      
            
      <div class="form-group">
        <label>Muhtemel (öngörülebilir) maruziyet yolları İngilizce</label>
        <input type="text" formControlName="foreseeableEnglish" class="form-control">
      </div>

       <div class="form-group">
        <label>Hedeflenen (veya maruz kalan) kişiler</label>
        <input type="text" formControlName="targetGroup" class="form-control">
      </div>

       <div class="form-group">
        <label>Hedeflenen (veya maruz kalan) kişiler İngilizce</label>
        <input type="text" formControlName="targetGroupEnglish" class="form-control">
      </div>






    
      
      
      <div class="form-group">
        <label>Ürün Fonksiyonu</label>
        <input type="text" formControlName="function" class="form-control">
      </div>
      
    
         
      <div class="form-group">
        <label>Ürün Fonksiyonu İngilizce</label>
        <input type="text" formControlName="functionEnglish" class="form-control">
      </div>

   
      <div class="form-group">
        <label>Referans</label>
        <input type="text" formControlName="reference" class="form-control">
      </div>
      
    
         
      <div class="form-group">
        <label>Referans İngilizce</label>
        <input type="text" formControlName="referenceEnglish" class="form-control">
      </div>

        <div class="form-group">
        <label>Ortalama vücut ağırlığı: </label>
        <input type="text" formControlName="bodyWeight" class="form-control">
      </div>
      
    </div>

    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Kaydet</button>
    </div>
  </form>
</div>